import { render, staticRenderFns } from "./AssignCompany.vue?vue&type=template&id=6211d388"
import script from "./AssignCompany.vue?vue&type=script&lang=js"
export * from "./AssignCompany.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/brkt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6211d388')) {
      api.createRecord('6211d388', component.options)
    } else {
      api.reload('6211d388', component.options)
    }
    module.hot.accept("./AssignCompany.vue?vue&type=template&id=6211d388", function () {
      api.rerender('6211d388', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/components/AssignCompany.vue"
export default component.exports